import { gql } from "@apollo/client";

export default gql`
  query getNewPackageCostInfo($data: newPackCostInput){
    getNewPackageCostInfo(data: $data){
        success
        data{
            feeCharge
            totalCost
            remindCost
            couponDiscount
            freeTrialLeftDays
            aiAssistantCost
        }
        code
        message
    }
}
`
